import { Timestamp, collection, doc, getDoc, onSnapshot, orderBy, query, setDoc, where } from "firebase/firestore";
import { useCallback, useEffect, useRef, useState } from "react";
import db from "../Backend";
import MyUnitsReports from "./MyUnitsReport";
import MyUnitLocations from "./MyUnitsAllocation";
import { getChapterUnitName, initDB } from "../ConfigureIndexedDB";
import { Button } from "@mui/material";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import MonthList from "./MonthList";
import { useNavigate } from "react-router-dom";

const ChapterDashb = ({tokenvalue}) => {
    const [username,setUserName]=useState("");
    const [unitallocations,setUnitAlloccations]=useState([]);
    const [yearofentry,setEntryYear]=useState("");
    const [yearonfocus,setYearOnFocus]=useState("");
    const [chapter_name,setChapterName]=useState("");
    const [allUnitreports,setAllreports]=useState([]);
    const [searchUnit,setUnitsearch]=useState("");
    const [monthQuery,setMonthQuery]=useState("");
    const [dateQuery,setDateQuery]=useState("");
    const [filteredUnit,setFilteredunit]=useState([]);
    const [showfilteredunit,setShowFilterunit]=useState(false);
    const [selectedAlloc,setSelectedAlloc]=useState([]);
    const [sumAllocations,setSumAllocs]=useState(0);
    const [selectedMonthAlloc,setSelectedMonthAlloc]=useState("");
    const [chapterAllocs,setChapterAllocs]=useState([]);
    const [allLocations,setAllLocations]=useState(null);
    const [showMyLocations,setMyUnitLocations]=useState(false);
    const [droplListUnits,setDropListUnits]=useState(false);
    const [showListofMonths,setShowListMonths]=useState(false);
    const [allocationFromChapter,setAllocationFromChapter]=useState(0);
    const [showLeftbarphone,setShowLeftsidephone]=useState(false);
    const [showRightbarphone,setShowRightbarphone]=useState(false);
    const [showGeneralquery,setShowGeneralquery]=useState(false);
    const [showYearQuery,setShowYearQuery]=useState(false);
    const closeLeftSideRef = useRef();
    const closeRightSidebarRef = useRef();

    const now = Timestamp.now();
    const dateSent = new Date(now?.toDate()).toUTCString();
    const navigate = useNavigate();

    const totalAmtalloc = useCallback(() => (Number(sumAllocations) * 0.60) + Number(allocationFromChapter),[sumAllocations,allocationFromChapter]);
    const chapterproceeds = useCallback(()=> (100/70) * Number(allocationFromChapter),[allocationFromChapter]);
    const totalproceeds = useCallback(() => chapterproceeds() + Number(sumAllocations),[chapterproceeds,sumAllocations]);
    const remainingProceeds = useCallback(() => totalproceeds() - totalAmtalloc(),[totalproceeds,totalAmtalloc]);

    useEffect(()=>{
        initDB().then(()=>{
            getChapterUnitName("cun")
            .then((data)=>{
                if(data){
                    setChapterName(data.chapter_name);
                    setUserName(data.user_name && data.user_name);
                }
            }).catch((err)=>{
                console.log(err);
            });
        }).catch((err)=>{
            console.log(err);
        });

        const currentDate = new Date();
        setEntryYear(currentDate.getFullYear().toString());
        setYearOnFocus(currentDate.getFullYear().toString());
    },[]);

    const changeYearOnFocus=(yearvalue)=>{
        if(yearonfocus !== ""){
            setEntryYear(yearvalue);
        }
    };

    useEffect(()=>{
        const collectionRef = collection(db,"unitremittances");
        const q = query(collectionRef,where("chapter_name","==",chapter_name),where("year","==",yearofentry),orderBy("date_sent","asc"));
        const unsub = onSnapshot(q, (snapshot)=>{
            const firedocs = [];
            snapshot.forEach((doc)=>{
                firedocs.push(doc.data());
            });
            setUnitAlloccations(firedocs);
        })
        return unsub;
    },[chapter_name,yearofentry]);

    useEffect(()=>{
        const collectionRef = collection(db,"weeklyreport");
        const q = query(collectionRef,where("chapter_name","==",chapter_name),where("yearofentry","==",yearofentry),orderBy("dateofentry","asc"));
        const unsub = onSnapshot(q, (snapshot)=>{
            const firedocs = [];
            snapshot.forEach((doc)=>{
                firedocs.push(doc.data());
            });
            setAllreports(firedocs);
        })
        return unsub;
    },[chapter_name,yearofentry]);

    useEffect(()=>{
        const collectionRef = collection(db,"chapterremittances");
        const q = query(collectionRef,where("chapter_name","==",chapter_name),where("year","==",yearofentry),orderBy("date_sent","asc"));
        const unsub = onSnapshot(q, (snapshot)=>{
            const firedocs = [];
            snapshot.forEach((doc)=>{
                firedocs.push(doc.data());
            });
            setChapterAllocs(firedocs);
        });
        return unsub;
    },[chapter_name,yearofentry]);

    useEffect(()=>{
        const chapterDocid = chapter_name.toLowerCase().replace(/\s/g,"");
       const timeid = setTimeout(() => {
            if(chapterDocid){
                const docRef = doc(db,"reports",`${chapterDocid}`);
                getDoc(docRef).then((snapshot)=>{
                    if(snapshot.exists()){
                        setAllLocations(snapshot.data());
                    }
                }).catch((err)=>{
                    console.log(err);
                });
            }
        }, 1000);
        return ()=>clearTimeout(timeid);
    },[chapter_name]);

    const Unitquery=(e)=>{
        e.preventDefault();
        if(allUnitreports.length > 0){
            if(monthQuery !== "" && searchUnit !== "" && dateQuery === ""){
                let result = allUnitreports.filter(myunit =>
                    myunit.unit_name.replace(/[^\w\s]|_/g, '').toLowerCase().includes(searchUnit.toLowerCase())
                    && myunit.monthofentry.toLowerCase().includes(monthQuery.toLowerCase()));
                  if(result.length > 0){
                    setFilteredunit(result);
                    setShowFilterunit(true);
                  }
            }else if(searchUnit !== "" && monthQuery === "" && dateQuery === ""){
                let result = allUnitreports.filter(myunit =>
                    myunit.unit_name.replace(/[^\w\s]|_/g, '').toLowerCase().includes(searchUnit.toLowerCase()));
                  if(result.length > 0){
                    setFilteredunit(result);
                    setShowFilterunit(true);
                  }
            }else if(searchUnit === "" && monthQuery !=="" && dateQuery === ""){
                let result = allUnitreports.filter(myunit =>
                    myunit.monthofentry.toLowerCase().includes(monthQuery.toLowerCase()));
                  if(result.length > 0){
                    setFilteredunit(result);
                    setShowFilterunit(true);
                  }
            }else if(searchUnit !== "" && dateQuery !== "" && monthQuery === ""){
                let result = allUnitreports.filter(myunit =>
                    myunit.unit_name.replace(/[^\w\s]|_/g, '').toLowerCase().includes(searchUnit.toLowerCase())
                    && myunit.dateofentry.replace(/[^\w\s]|_/g, '').toLowerCase().includes(dateQuery.toLowerCase().replace(/[^\w\s]|_/g, '')));
                  if(result.length > 0){
                    setFilteredunit(result);
                    setShowFilterunit(true);
                  }
            }else if(searchUnit === "" && monthQuery === "" && dateQuery !== ""){
                let result = allUnitreports.filter(myunit =>
                    myunit.dateofentry.replace(/[^\w\s]|_/g, '').toLowerCase().includes(dateQuery.toLowerCase().replace(/[^\w\s]|_/g, '')));
                  if(result.length > 0){
                    setFilteredunit(result);
                    setShowFilterunit(true);
                  }
            }
        }
    };

    const resetQueryfield=()=>{
        setFilteredunit([]);
        setShowFilterunit(false);
        setUnitsearch("");
        setMonthQuery("");
        setDateQuery("");
    };

    const getSelectedMonthAlloc=(selected_mth,amt,ischecked,unitondoc)=>{
        if(ischecked){
           
            if(unitondoc.replace(/[^\w\s]|_/g, '').toLowerCase().split(" ").includes("chapter")){
                setAllocationFromChapter(amt);
                setSelectedMonthAlloc(selected_mth);
            }else{
                setSelectedAlloc(prev => [...prev,amt]);
                setSelectedMonthAlloc(selected_mth);
            }
        }else{
            setSelectedAlloc(prev => prev.filter(total => total !== amt));
            setSelectedMonthAlloc(selected_mth);
            setAllocationFromChapter(0);
        }
        totalAmtalloc();
    };

    useEffect(()=>{
        let sum = 0;
        if(selectedAlloc.length > 0){
            sum = selectedAlloc.reduce((a,b) => a + Number(b),0);
        }
        setSumAllocs(sum);
    },[selectedAlloc,sumAllocations]);

    const handleRemittance=async()=>{
        if(sumAllocations !== 0){
            try{
                await setDoc(doc(db,"chapterremittances",`${selectedMonthAlloc+yearofentry+chapter_name}`),{
                    chapter_name,
                    total_month_income: totalproceeds(),
                    month_on_focus: selectedMonthAlloc,
                    chapterproceeds: chapterproceeds(),
                    unitproceeds: sumAllocations,
                    amount_alloted: totalAmtalloc(),
                    netincome: remainingProceeds(),
                    date_sent: dateSent,
                    year: yearofentry,
                    username 
                });
                alert("sucess");
            }catch{
    
            }
        }
    };

    const handleResetTotals=()=>{
        setSelectedAlloc([]);
        setSumAllocs(0);
        setSelectedMonthAlloc("");
        setAllocationFromChapter(0);
    };
    const handleSetUnitintoquery=(unitname)=>{
        setUnitsearch(unitname);
        setMyUnitLocations(false);
    };
    const handleSetUnitintoquery2=(unitname)=>{
        setUnitsearch(unitname);
        setDropListUnits(false);
    };
    const handleInsertMonth=(month)=>{
        setMonthQuery(month);
        setShowListMonths(false);
    };
    const goToReport=()=>{
        sessionStorage.setItem("token","verified");
        const tvalue = sessionStorage.getItem("token");
        tokenvalue(tvalue); 
       const timeid = setTimeout(() => {
          navigate("/report/form");
        }, 500);
        return ()=> clearTimeout(timeid);
    };

    useEffect(() => {
        const clearLeftSidebar=(e)=>{
            if(!closeLeftSideRef.current.contains(e.target)){
                setShowLeftsidephone(false);
            }
        }
        const clearrightSidebar=(e)=>{
            if(!closeRightSidebarRef.current.contains(e.target)){
                setShowRightbarphone(false);
            }
        }
        document.addEventListener('mousedown',clearLeftSidebar);
        document.addEventListener('mousedown',clearrightSidebar)
        return ()=>{
            document.removeEventListener('mousedown',clearLeftSidebar);
            document.removeEventListener('mousedown',clearrightSidebar);
        }
    },[]);
    



    return (  
        <div className="chapterdashboard">
            <div className="topchapterdashb flex-spacebetween">
                <form onSubmit={Unitquery}>
                <fieldset>
                    <legend>General query</legend>
                    <div className="flex-row3">
                        
                    <div className="myunitsdroplistdiv flex-row2" style={{position:"relative"}}>
                    <input type="search" placeholder="enter unit name" value={searchUnit} onChange={e => setUnitsearch(e.target.value)}/>
                    <button onClick={()=>setDropListUnits(prev => !prev)}>
                        <ArrowDropDownIcon/>
                    </button>
                    {droplListUnits && 
                        <div className="dropmylocations flex-column1">
                            {allLocations.unit1 && <button onClick={()=>handleSetUnitintoquery2(allLocations.unit1)}>{allLocations.unit1}</button>}
                            {allLocations.unit2 && <button onClick={()=>handleSetUnitintoquery2(allLocations.unit2)}>{allLocations.unit2}</button>}
                            {allLocations.unit3 && <button onClick={()=>handleSetUnitintoquery2(allLocations.unit3)}>{allLocations.unit3}</button>}
                            {allLocations.unit4 && <button onClick={()=>handleSetUnitintoquery2(allLocations.unit4)}>{allLocations.unit4}</button>}
                            {allLocations.unit5 && <button onClick={()=>handleSetUnitintoquery2(allLocations.unit5)}>{allLocations.unit5}</button>}
                            {allLocations.unit6 && <button onClick={()=>handleSetUnitintoquery2(allLocations.unit6)}>{allLocations.unit6}</button>}
                            {allLocations.unit7 && <button onClick={()=>handleSetUnitintoquery2(allLocations.unit7)}>{allLocations.unit7}</button>}
                            {allLocations.unit8 && <button onClick={()=>handleSetUnitintoquery2(allLocations.unit8)}>{allLocations.unit8}</button>}
                            {allLocations.unit9 && <button onClick={()=>handleSetUnitintoquery2(allLocations.unit9)}>{allLocations.unit9}</button>}
                            {allLocations.unit10 && <button onClick={()=>handleSetUnitintoquery2(allLocations.unit10)}>{allLocations.unit10}</button>}
                        </div>
                    }
                    </div>
                   
                    <div className="flex-row2" style={{position:"relative"}}>
                    <input type="search" placeholder="month" value={monthQuery} onChange={e => setMonthQuery(e.target.value)}/>
                    <button onClick={()=>setShowListMonths(prev => !prev)}>
                        <ArrowDropDownIcon/>
                    </button>
                    {showListofMonths &&
                        <div className="listofmonths">
                            <MonthList selectedmonth={handleInsertMonth} />
                        </div>
                    }
                    </div>
                    <fieldset>
                        <legend>date</legend>
                        <input type="date" placeholder="date" value={dateQuery} onChange={e => setDateQuery(e.target.value)}/>
                    </fieldset>
                   
                    <button>query</button>
                    {showfilteredunit && <Button onClick={resetQueryfield}>Reset</Button>}
                    </div>
                </fieldset>
                </form>
                <div className="chapterdashbunitnames flex-row2">
                    <h3>My Units</h3>
                    <svg
                    onClick={()=>setMyUnitLocations(prev => !prev)}
                    cursor="pointer"
                    viewBox="0 0 24 24"
                    fill="#000000"
                    height="1.5em"
                    width="1.5em">
                    <path fill="none" d="M0 0h24v24H0V0z" />
                    <path d="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z" />
                    </svg>

                    {showMyLocations && 
                        <div className="dropmylocations flex-column1">
                            {allLocations.unit1 && <button onClick={()=>handleSetUnitintoquery(allLocations.unit1)}>{allLocations.unit1}</button>}
                            {allLocations.unit2 && <button onClick={()=>handleSetUnitintoquery(allLocations.unit2)}>{allLocations.unit2}</button>}
                            {allLocations.unit3 && <button onClick={()=>handleSetUnitintoquery(allLocations.unit3)}>{allLocations.unit3}</button>}
                            {allLocations.unit4 && <button onClick={()=>handleSetUnitintoquery(allLocations.unit4)}>{allLocations.unit4}</button>}
                            {allLocations.unit5 && <button onClick={()=>handleSetUnitintoquery(allLocations.unit5)}>{allLocations.unit5}</button>}
                            {allLocations.unit6 && <button onClick={()=>handleSetUnitintoquery(allLocations.unit6)}>{allLocations.unit6}</button>}
                            {allLocations.unit7 && <button onClick={()=>handleSetUnitintoquery(allLocations.unit7)}>{allLocations.unit7}</button>}
                            {allLocations.unit8 && <button onClick={()=>handleSetUnitintoquery2(allLocations.unit8)}>{allLocations.unit8}</button>}
                            {allLocations.unit9 && <button onClick={()=>handleSetUnitintoquery2(allLocations.unit9)}>{allLocations.unit9}</button>}
                            {allLocations.unit10 && <button onClick={()=>handleSetUnitintoquery2(allLocations.unit10)}>{allLocations.unit10}</button>}
                        </div>
                    }
                </div>

               <Button onClick={goToReport}>Report</Button>

                <h3>{chapter_name}</h3>
      
                <fieldset>
                    <legend>Year on Focus</legend>
                    <div className="flex-row2">
                    <input type="search" value={yearonfocus} required onChange={e => setYearOnFocus(e.target.value)}/>
                    <button onClick={()=>changeYearOnFocus(yearonfocus)}>Change</button>
                    </div>
                </fieldset>
            </div>

            <div className="topchapterdashb-phone flex-spacebetween">
                <form onSubmit={Unitquery}>
                <fieldset className={`chaptergeneralquery ${showGeneralquery ? 'open' : 'close'}`}>
                    <legend>General query</legend>
                    <div className="flex-row3" style={{flexWrap:"wrap",gap:"10px"}}>
                        
                    <div className="myunitsdroplistdiv flex-row2" style={{position:"relative",width:"90%"}}>
                    <input type="search" placeholder="enter unit name" value={searchUnit} onChange={e => setUnitsearch(e.target.value)}/>
                    <button onClick={()=>setDropListUnits(prev => !prev)}>
                        <ArrowDropDownIcon/>
                    </button>
                    {droplListUnits && 
                        <div className="dropmylocations flex-column1">
                            {allLocations.unit1 && <button onClick={()=>handleSetUnitintoquery2(allLocations.unit1)}>{allLocations.unit1}</button>}
                            {allLocations.unit2 && <button onClick={()=>handleSetUnitintoquery2(allLocations.unit2)}>{allLocations.unit2}</button>}
                            {allLocations.unit3 && <button onClick={()=>handleSetUnitintoquery2(allLocations.unit3)}>{allLocations.unit3}</button>}
                            {allLocations.unit4 && <button onClick={()=>handleSetUnitintoquery2(allLocations.unit4)}>{allLocations.unit4}</button>}
                            {allLocations.unit5 && <button onClick={()=>handleSetUnitintoquery2(allLocations.unit5)}>{allLocations.unit5}</button>}
                            {allLocations.unit6 && <button onClick={()=>handleSetUnitintoquery2(allLocations.unit6)}>{allLocations.unit6}</button>}
                            {allLocations.unit7 && <button onClick={()=>handleSetUnitintoquery2(allLocations.unit7)}>{allLocations.unit7}</button>}
                            {allLocations.unit8 && <button onClick={()=>handleSetUnitintoquery2(allLocations.unit8)}>{allLocations.unit8}</button>}
                            {allLocations.unit9 && <button onClick={()=>handleSetUnitintoquery2(allLocations.unit9)}>{allLocations.unit9}</button>}
                            {allLocations.unit10 && <button onClick={()=>handleSetUnitintoquery2(allLocations.unit10)}>{allLocations.unit10}</button>}
                        </div>
                    }
                    </div>
                   
                    <div className="flex-row2" style={{position:"relative",width:"90%"}}>
                    <input type="search" placeholder="month" value={monthQuery} onChange={e => setMonthQuery(e.target.value)}/>
                    <button onClick={()=>setShowListMonths(prev => !prev)}>
                        <ArrowDropDownIcon/>
                    </button>
                    {showListofMonths &&
                        <div className="listofmonths">
                            <MonthList selectedmonth={handleInsertMonth} />
                        </div>
                    }
                    </div>
                   
                    <fieldset style={{width:"80%"}}>
                        <legend>date</legend>
                        <input type="date" placeholder="date" value={dateQuery} onChange={e => setDateQuery(e.target.value)}/>
                    </fieldset>
              
                    <button>query</button>
                    {showfilteredunit && <Button onClick={resetQueryfield}>Reset</Button>}
                    </div>
                </fieldset>
                </form>

                {!showYearQuery && 
                 <div className="flex-column1" onClick={()=>setShowGeneralquery(prev => !prev)}>
                 <h4>query</h4>
                 <svg
                 viewBox="0 0 24 24"
                 fill="currentColor"
                 height="2em"
                 width="2em">
                 <path d="M21 3H5a1 1 0 00-1 1v2.59c0 .523.213 1.037.583 1.407L10 13.414V21a1.001 1.001 0 001.447.895l4-2c.339-.17.553-.516.553-.895v-5.586l5.417-5.417c.37-.37.583-.884.583-1.407V4a1 1 0 00-1-1zm-6.707 9.293A.996.996 0 0014 13v5.382l-2 1V13a.996.996 0 00-.293-.707L6 6.59V5h14.001l.002 1.583-5.71 5.71z" />
                 </svg>
                 </div>
                }
               

               {!showGeneralquery && !showYearQuery && <Button onClick={goToReport}>Report</Button>}
               {!showGeneralquery && !showYearQuery &&  <h3>{chapter_name}</h3>}
              
      
                <fieldset className={`chapteryearqueryfield ${showYearQuery ? 'open' : 'close'}`}>
                    <legend>Year on Focus</legend>
                    <div className="flex-row2">
                    <input type="search" value={yearonfocus} required onChange={e => setYearOnFocus(e.target.value)}/>
                    <button onClick={()=>changeYearOnFocus(yearonfocus)}>Change</button>
                    </div>
                </fieldset>

                {!showGeneralquery && 
                    <div className="flex-column1" onClick={()=>setShowYearQuery(prev => !prev)}>
                    <h4>Year</h4>
                    <svg
                    viewBox="0 0 24 24"
                    fill="currentColor"
                    height="2em"
                    width="2em">
                    <path d="M7 11h2v2H7zm0 4h2v2H7zm4-4h2v2h-2zm0 4h2v2h-2zm4-4h2v2h-2zm0 4h2v2h-2z" />
                    <path d="M5 22h14c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2h-2V2h-2v2H9V2H7v2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2zM19 8l.001 12H5V8h14z" />
                    </svg>
                    </div>
                }
         
            </div>

            <div className="chapterdashbody">
                 <div className="leftchapterdashbar">
                 <div className="leftchapterdashbcontent">
                 <h2>unit accounts</h2>

                    {unitallocations && unitallocations.map(data => (
                            <MyUnitLocations
                                key={data.date_sent}
                                month_on_focus={data.month_on_focus}
                                amount_alloted={data.amount_alloted}
                                date_sent={data.date_sent}
                                unit_name={data.unit_name}
                                username={data.username}
                                total_month_income={data.total_month_income}
                                onChecked={getSelectedMonthAlloc}
                            />
                    ))}
                 </div>
             
                </div>

                <div className="middledashbar">
                <div className="middledashbarphonetop">
                    <div className="flex-column1" onClick={()=>setShowLeftsidephone(true)}>
                        <h4 style={{color:"black"}}>Inflows</h4>
                        <svg
                        viewBox="0 0 24 24"
                        fill="black">
                        <path d="M21 11h-3V4a1 1 0 00-1-1H3a1 1 0 00-1 1v14c0 1.654 1.346 3 3 3h14c1.654 0 3-1.346 3-3v-6a1 1 0 00-1-1zM5 19a1 1 0 01-1-1V5h12v13c0 .351.061.688.171 1H5zm15-1a1 1 0 01-2 0v-5h2v5z" />
                        <path d="M6 7h8v2H6zm0 4h8v2H6zm5 4h3v2h-3z" />
                        </svg>
                    </div>

                    <div className="flex-column1" onClick={()=>setShowRightbarphone(true)}>
                        <h4 style={{color:"black"}}>Allocation</h4>
                        <svg
                        viewBox="0 0 24 24"
                        fill="black">
                        <path d="M11.293 17.293l1.414 1.414L19.414 12l-6.707-6.707-1.414 1.414L15.586 11H6v2h9.586z" />
                        </svg>
                    </div>
                </div>
                <h2>{!showfilteredunit ? 'All unit reports' : searchUnit !== "" && monthQuery === "" ? `Report for: ${searchUnit } unit`
                    : monthQuery !== "" && searchUnit === "" ? `Reports on ${monthQuery}` 
                    : searchUnit !== "" && monthQuery !== "" ? `Report for: ${searchUnit } unit on ${monthQuery}`
                     : `Reports on ${dateQuery}` }
                    
                </h2>
                    {!showfilteredunit && 
                    <div className="middledashbarcontent flex-row2">
                    
                        {allUnitreports && allUnitreports.map(data =>(
                            <MyUnitsReports
                            key={`${data.dateofentry+data.unit_name}`}
                            unit_name={data.unit_name}
                            username={data.username}
                            dateofentry={data.dateofentry}
                            monthofentry={data.monthofentry}
                            yearofentry={data.yearofentry}
                            message={data.message}
                            men = {data.men}
                            women={data.women}
                            youth={data.youth}
                            children={data.children}
                            total_attend={data.total_attend}
                            tithe={data.tithe}
                            offering={data.offering}
                            total={data.total}
                            menAttend={data.menAttend}
                            womenAttend={data.womenAttend}
                            youthAttend={data.youthAttend}
                            childAttend={data.childAttend}
                            expenditure={data.expenditure}
                            expensedetails={data.expensedetails}
                            remainingIncome={data.remainingIncome}
                            remarks={data.remarks}
                            />
                        ))}
                    </div>
                    }
                    

                    {showfilteredunit && 
                         <div className="middledashbarcontent flex-row2">
                            {filteredUnit && filteredUnit.map(data =>(
                            <MyUnitsReports
                            key={`${data.dateofentry+data.unit_name}`}
                            unit_name={data.unit_name}
                            username={data.username}
                            dateofentry={data.dateofentry}
                            monthofentry={data.monthofentry}
                            yearofentry={data.yearofentry}
                            message={data.message}
                            men = {data.men}
                            women={data.women}
                            youth={data.youth}
                            children={data.children}
                            total_attend={data.total_attend}
                            tithe={data.tithe}
                            offering={data.offering}
                            total={data.total}
                            menAttend={data.menAttend}
                            womenAttend={data.womenAttend}
                            youthAttend={data.youthAttend}
                            childAttend={data.childAttend}
                            expenditure={data.expenditure}
                            expensedetails={data.expensedetails}
                            remainingIncome={data.remainingIncome}
                            />
                        ))}
                        </div>
                    }
                </div>

                <div className="rightchapterdashbar">
                    <h2>Monthly Allocation</h2>
                    <div className="rightchapterdashbcontent flex-column1">
                    <h3>{selectedMonthAlloc} Allocation</h3>
                    <h4>Income from Units {parseFloat(sumAllocations).toLocaleString('en-US',{style:'currency',currency:"GHS"})}</h4>
                    <h4>60% of Income: {parseFloat(sumAllocations * 0.60).toLocaleString('en-US',{style:'currency',currency:"GHS"})}</h4>
                        <h3>+</h3>
                    <h4>{`70% Chapter Income GHS ${parseFloat(allocationFromChapter).toLocaleString('en-US',{style:"currency",currency:"GHS"})}`}</h4>
                    <h4>
                        Total amount to allocate {parseFloat(totalAmtalloc()).toLocaleString('en-US',{style:'currency',currency:"GHS"})}
                    </h4>
                    <div className="flex-row2" style={{gap:"10px"}}>
                    <button onClick={handleRemittance}>Allocate</button>
                    <button onClick={handleResetTotals}>Reset</button>
                    </div>  <br/>

                    <h3>{`Statement of account (${yearofentry}):`}</h3>
                    {chapterAllocs && chapterAllocs.map(data => (
                        <div className="flex-column2" style={{gap:"5px",marginBottom:"2em"}} key={data.date_sent}>
                             <h3 style={{borderBottom:"1px solid black"}}>{data.month_on_focus}</h3>
                             <h4>{`Inflows from Unit: ${parseFloat(data.unitproceeds).toLocaleString('en-US',{style:"currency",currency:"GHS"})}`}</h4>
                             <h4>{`Inflows from Chapter: ${parseFloat(data.chapterproceeds).toLocaleString('en-US',{style:"currency",currency:"GHS"})}`}</h4>
                            <h4>{`Total Inflows: ${parseFloat(data.total_month_income).toLocaleString('en-US',{style:"currency",currency:"GHS"})}`}</h4>
                            <h4>{`Ammount alloted: ${parseFloat(data.amount_alloted).toLocaleString('en-US',{style:"currency",currency:"GHS"})}`}</h4>
                            <h4>{`Net(Surplus/at par): ${parseFloat(data.netincome).toLocaleString('en-US',{style:"currency",currency:"GHS"})}`}</h4>
                        </div>
                    ))}
                    </div>
            
                </div>
            </div>

            <div className={`leftchapterdashbar-phone ${showLeftbarphone ? 'open' : 'close'}`} ref={closeLeftSideRef}>
                 <div className="leftchapterdashbcontent">
                 <h2>unit allocations</h2>

                    {unitallocations && unitallocations.map(data => (
                            <MyUnitLocations
                                key={data.date_sent}
                                month_on_focus={data.month_on_focus}
                                amount_alloted={data.amount_alloted}
                                date_sent={data.date_sent}
                                unit_name={data.unit_name}
                                username={data.username}
                                total_month_income={data.total_month_income}
                                onChecked={getSelectedMonthAlloc}
                            />
                        ))}
                 </div>
            </div>

            <div className={`rightchapterdashbar-phone ${showRightbarphone ? 'open' : 'close'}`} ref={closeRightSidebarRef}>
                    <h2>Monthly Allocation</h2>
                    <div className="rightchapterdashbcontent flex-column1">
                    <h3>{selectedMonthAlloc} Allocation</h3>
                    <h4>Income from Units {parseFloat(sumAllocations).toLocaleString('en-US',{style:'currency',currency:"GHS"})}</h4>
                    <h4>60% of Income: {parseFloat(sumAllocations * 0.60).toLocaleString('en-US',{style:'currency',currency:"GHS"})}</h4>
                        <h3>+</h3>
                    <h4>{`70% Chapter Income GHS ${parseFloat(allocationFromChapter).toLocaleString('en-US',{style:"currency",currency:"GHS"})}`}</h4>
                    <h4>
                        Total amount to allocate {parseFloat(totalAmtalloc()).toLocaleString('en-US',{style:'currency',currency:"GHS"})}
                    </h4>
                    <div className="flex-row2" style={{gap:"10px"}}>
                    <button onClick={handleRemittance}>Allocate</button>
                    <button onClick={handleResetTotals}>Reset</button>
                    </div>  <br/>

                    <h3>{`Statement of account (${yearofentry}):`}</h3>
                    {chapterAllocs && chapterAllocs.map(data => (
                        <div className="flex-column2" style={{gap:"5px",marginBottom:"2em"}} key={data.date_sent}>
                             <h3 style={{borderBottom:"1px solid black"}}>{data.month_on_focus}</h3>
                             <h4>{`Inflows from Unit: ${parseFloat(data.unitproceeds).toLocaleString('en-US',{style:"currency",currency:"GHS"})}`}</h4>
                             <h4>{`Inflows from Chapter: ${parseFloat(data.chapterproceeds).toLocaleString('en-US',{style:"currency",currency:"GHS"})}`}</h4>
                            <h4>{`Total Inflows: ${parseFloat(data.total_month_income).toLocaleString('en-US',{style:"currency",currency:"GHS"})}`}</h4>
                            <h4>{`Ammount alloted: ${parseFloat(data.amount_alloted).toLocaleString('en-US',{style:"currency",currency:"GHS"})}`}</h4>
                            <h4>{`Net(Surplus/at par): ${parseFloat(data.netincome).toLocaleString('en-US',{style:"currency",currency:"GHS"})}`}</h4>
                        </div>
                    ))}
                    </div>
            
            </div>
   
        </div>
    );
}
export default ChapterDashb;